export default {
    moods: [
        'Super Stressed',
        'Anxious',
        'Somewhere in Between',
        'Content',
        'Completely Chill'
    ]
};
